import { EngagementSurveyContext } from 'context/engagementsurveycontext';
import { useContext, useState, useEffect } from 'react';

const EngagementSurveyQuestions = () => {

    const [pageEmailAddress, setPageEmailAddress] = useState('');
    const [emailError, setEmailError] = useState('');
    const [nameError, setNameError] = useState('');

    const {
        emailAddress,
        setEmailAddress,
        surveyFName,
        setSurveyFName,
        surveyLName,
        setSurveyLName,
        questions,
        isLoading,
        isError,
        getSurveyQuestionsForId,
        setQuestions,
        submit,
        namedSurveyId
    } = useContext(EngagementSurveyContext);

    const getSurveyQs = async () => {
        await getSurveyQuestionsForId({ emailAddress, namedSurveyId });
    }

    useEffect(() => {
        getSurveyQs();
    }, [emailAddress]);

    const getSurveyData = (event) => {
        event.preventDefault();
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if(surveyFName === null || surveyFName === undefined || surveyFName == ''){
            setNameError('First name is required');
        }
        else if(surveyLName === null || surveyLName === undefined || surveyLName == ''){
            setNameError('Last name is required');
        }
        else if (emailRegex.test(pageEmailAddress) === false) {
            setEmailError('Please enter a valid email address');
        }
        else{
            setEmailAddress(pageEmailAddress);
        }
    }

    function submitForm(event) {
        event.preventDefault();
        submit({ emailAddress}, {surveyFName }, {surveyLName}, { questions });
        return false;
    }

    const OnEmailChanged = (event) => {
        setPageEmailAddress(event.target.value);
    }

    const OnSurveyFNameChanged = (event) =>{
        setSurveyFName(event.target.value);
    }

    const OnSurveyLNameChanged = (event) =>{
        setSurveyLName(event.target.value);
    }

    const updateSurveyQuestion = (event) => {
        const selVal = event.target.value;
        const splitValues = selVal.split('-');

        const questionId = splitValues[0];
        const answerVal = splitValues[1];

        for (let i = 0; i < questions.length; i++) {
            if (questions[i].questionId === parseInt(questionId)) {
                questions[i].answer = parseInt(answerVal);
                setQuestions(questions);
                break;
            }
        }
    }

    if (!isLoading) {
        const answerChoices = ['5 - Strongly Agree', '4 - Agree', '3 - Neutral', '2 - Disagree', '1 - Strongly Disagree'];

        if (emailAddress !== null && emailAddress !== undefined && emailAddress !== '') {
            return (

                <div style={isError ? { display: 'none', paddingBottom: '50px' } : {paddingBottom: '50px'}}>
                    <form onSubmit={submitForm}>
                        {
                            questions.map((q, index) => {
                                const answerNm = 'answer' + index;
                                return (
                                    <div className='container-fluid' key={answerNm}>
                                        <div className='checkbox'>
                                            <h4 className='checkbox-heading mb-4'>{q.question}</h4>
                                            <div className='control-group' aria-required='true' required onChange={updateSurveyQuestion}>
                                                <label className='control-single-survey control-checkbox'>
                                                    {answerChoices[0]}
                                                    <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-5'} />
                                                    <div className='control_indicator'></div>
                                                </label>
                                                <label className='control-single-survey control-checkbox'>
                                                    {answerChoices[1]}
                                                    <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-4'} />
                                                    <div className='control_indicator'></div>
                                                </label>
                                                <label className='control-single-survey control-checkbox'>
                                                    {answerChoices[2]}
                                                    <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-3'} />
                                                    <div className='control_indicator'></div>
                                                </label>
                                                <label className='control-single-survey control-checkbox'>
                                                    {answerChoices[3]}
                                                    <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-2'} />
                                                    <div className='control_indicator'></div>
                                                </label>
                                                <label className='control-single-survey control-checkbox'>
                                                    {answerChoices[4]}
                                                    <input type='radio' required className={'cb' + index} id={'cb' + index} name={answerNm} value={q.questionId + '-1'} />
                                                    <div className='control_indicator'></div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className='contaner-fluid text-center pt-5'>
                            <button type='submit' className='submit-button-single-survey'>Submit</button>
                        </div>
                    </form>
                </div>
            )
        }
        else {
            return (
                <div style={{width:'100%',marginBottom:70}}>
                    <form onSubmit={getSurveyData} >
                        <div className='container form-data'>
                            <div className='textbox-form'>
                                <label className='control-label'>First Name:</label><br />
                                <input type='text'
                                    style={{ width: 350 }}
                                    value={surveyFName}
                                    required
                                    onChange={OnSurveyFNameChanged} />
                                <label style={{ color: 'red', fontSize: 15 }}>{nameError}</label>
                            </div>
                            <div className='textbox-form'>
                                <label className='control-label'>Last Name:</label><br />
                                <input type='text'
                                    style={{ width: 350 }}
                                    value={surveyLName}
                                    required
                                    onChange={OnSurveyLNameChanged} />
                                <label style={{ color: 'red', fontSize: 15 }}>{nameError}</label>
                            </div>
                            <div className='textbox-form'>
                                <label className='control-label'>Email address:</label><br />
                                <input type='email'
                                    style={{ width: 350 }}
                                    value={pageEmailAddress}
                                    required
                                    onChange={OnEmailChanged} />
                                <label style={{ color: 'red', fontSize: 15 }}>{emailError}</label>
                            </div>
                            <div className='contaner-fluid text-center pt-5'>
                                <button className='submit-button-form-single-survey' type='submit'>Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            )
        }

    }
    else {
        return <div>Loading...</div>
    }

};

export default EngagementSurveyQuestions;